import appSlice from "./appSlice";

export const commonReducer = {
    app: appSlice,
}